import type { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export class CacheService {
    constructor(private readonly cache: Map<string, unknown> = new Map()) {}

    public get<T>(key: string): T | null {
        return (this.cache.get(key) as T) ?? null;
    }

    public set<T>(key: string, item: T): T {
        this.cache.set(key, item);
        return item;
    }

    public withCache<T>(key: string, lazy: () => T): T {
        const item = this.get(key);
        if (item !== null) return item as T;

        const newItem = lazy();
        this.set(key, newItem);

        return newItem;
    }

    public withCachedObservable<T>(key: string, lazy: () => Observable<T>): Observable<T> {
        /**
         * Using shareReplay makes sure that subsequent subscriptions will yield latest item
         * instead of creating the observable from scratch
         */
        return this.withCache<Observable<T>>(key, () => lazy().pipe(shareReplay(1)));
    }

    public clear() {
        this.cache.clear();
    }
}
